export const GET_SAMPLE_FILE = 'GET_SAMPLE_FILE'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
